/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Meta_TitleInputs */

const en_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const es_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campo de práctica | Mark Egly Golf`)
};

const de_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const zh_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习场 | Mark Egly Golf`)
};

const ar_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميدان التدريب | Mark Egly Golf`)
};

const fr_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice | Mark Egly Golf`)
};

const vi_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sân tập | Mark Egly Golf`)
};

const sw_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const th_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามไดร์ฟกอล์ฟ | Mark Egly Golf`)
};

const bs_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vježbalište | Mark Egly Golf`)
};

const ja_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドライビングレンジ | Mark Egly Golf`)
};

const ko_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`드라이빙 레인지 | Mark Egly Golf`)
};

const pt_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const it_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const sv_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const nl_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const da_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const nb_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const fi_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const pl_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const ru_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const tr_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const hi_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्राइविंग रेंज | Mark Egly Golf`)
};

const id_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const ms_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const cs_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const el_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const he_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const af_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

const hu_range_meta_title = /** @type {(inputs: Range_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Driving Range \| Mark Egly Golf" |
*
* @param {Range_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_meta_title = /** @type {((inputs?: Range_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_meta_title(inputs)
	if (locale === "de") return de_range_meta_title(inputs)
	if (locale === "zh") return zh_range_meta_title(inputs)
	if (locale === "ar") return ar_range_meta_title(inputs)
	if (locale === "fr") return fr_range_meta_title(inputs)
	if (locale === "vi") return vi_range_meta_title(inputs)
	if (locale === "sw") return sw_range_meta_title(inputs)
	if (locale === "th") return th_range_meta_title(inputs)
	if (locale === "bs") return bs_range_meta_title(inputs)
	if (locale === "ja") return ja_range_meta_title(inputs)
	if (locale === "ko") return ko_range_meta_title(inputs)
	if (locale === "pt") return pt_range_meta_title(inputs)
	if (locale === "it") return it_range_meta_title(inputs)
	if (locale === "sv") return sv_range_meta_title(inputs)
	if (locale === "nl") return nl_range_meta_title(inputs)
	if (locale === "da") return da_range_meta_title(inputs)
	if (locale === "nb") return nb_range_meta_title(inputs)
	if (locale === "fi") return fi_range_meta_title(inputs)
	if (locale === "pl") return pl_range_meta_title(inputs)
	if (locale === "ru") return ru_range_meta_title(inputs)
	if (locale === "tr") return tr_range_meta_title(inputs)
	if (locale === "hi") return hi_range_meta_title(inputs)
	if (locale === "id") return id_range_meta_title(inputs)
	if (locale === "ms") return ms_range_meta_title(inputs)
	if (locale === "cs") return cs_range_meta_title(inputs)
	if (locale === "el") return el_range_meta_title(inputs)
	if (locale === "he") return he_range_meta_title(inputs)
	if (locale === "af") return af_range_meta_title(inputs)
	if (locale === "hu") return hu_range_meta_title(inputs)
	return en_range_meta_title(inputs)
});